import { render } from "./autocompleteTeachers.vue?vue&type=template&id=e2babe8a"
import script from "./autocompleteTeachers.vue?vue&type=script&lang=js"
export * from "./autocompleteTeachers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__